import { categories } from "@/mocks/catalog";

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-secondary-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-3">
          <div className="flex flex-col gap-4">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-film-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-semibold text-background-50">星辰影院</span>
            </div>
            <p className="max-w-sm text-sm leading-relaxed text-secondary-200">
              一个把动作片、爱情片、科幻片、恐怖片、喜剧片与电视剧整理在一起的类型导览站，帮助你在开始观看前先找到方向。
            </p>
          </div>

          <div className="flex flex-col gap-4">
            <h3 className="font-heading text-sm font-semibold text-background-50">类型分区</h3>
            <ul className="grid grid-cols-2 gap-2 text-sm">
              {categories.map((cat) => (
                <li key={cat.anchor}>
                  <a
                    href={`#${cat.anchor}`}
                    className="text-secondary-200 transition-colors hover:text-primary-300"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="flex flex-col gap-4">
            <h3 className="font-heading text-sm font-semibold text-background-50">快速入口</h3>
            <ul className="flex flex-col gap-2 text-sm">
              <li>
                <a href="#featured" className="text-secondary-200 transition-colors hover:text-primary-300">
                  本周精选
                </a>
              </li>
              <li>
                <a href="#explorer" className="text-secondary-200 transition-colors hover:text-primary-300">
                  片库类型筛选
                </a>
              </li>
              <li>
                <a href="#ranking" className="text-secondary-200 transition-colors hover:text-primary-300">
                  热播榜单
                </a>
              </li>
              <li>
                <a href="#faq" className="text-secondary-200 transition-colors hover:text-primary-300">
                  观影指南
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-secondary-700 pt-6 text-xs text-secondary-300 sm:flex-row sm:items-center sm:justify-between">
          <p>星辰影院 · 影视类型导览页，内容用于分类浏览参考</p>
          <p>页面为单页展示，导航均指向本页分区</p>
        </div>
      </div>
    </footer>
  );
}